/**
 * The symbols a course may carry (#574): an identifier glyph, like the colour, never a status.
 * Subject families come from the HUJI catalogue snapshot (a code -> family table); the seven maths sub-keys are picked by title
 * keywords INSIDE mathematics only; `letter` is the first letter of the short name. Hand-authored, not generated:
 * `schemas/course-update-request.json` and `course-response.json` list the same keys, and `course-symbols.test.ts` fails on drift.
 */
export const COURSE_FAMILY_SYMBOLS = [
  'medicine',
  'economics',
  'languages',
  'education',
  'sociology',
  'law',
  'history',
  'politics',
  'life-sciences',
  'agriculture',
  'psychology',
  'area-studies',
  'computer-science',
  'chemistry',
  'philosophy',
  'mathematics',
  'physics',
  'religion',
  'geography',
  'earth',
  'communication',
  'arts',
  'statistics',
] as const;

export const COURSE_MATHS_SYMBOLS = ['calculus', 'linear-algebra', 'discrete', 'algebra', 'geometry', 'number-theory', 'probability'] as const;

export const COURSE_SYMBOLS = [...COURSE_FAMILY_SYMBOLS, ...COURSE_MATHS_SYMBOLS, 'letter'] as const;

export type CourseFamily = (typeof COURSE_FAMILY_SYMBOLS)[number];
export type CourseSymbolKey = (typeof COURSE_SYMBOLS)[number];
